// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var AgentInfo_agent_graphql = require("../../../__generated__/AgentInfo_agent_graphql.bs.js");
var TerminatedAgentIconOverlay = require("./TerminatedAgentIconOverlay.bs.js");

var convertFragment = AgentInfo_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentInfo_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentInfo_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment_membershipStatusV5_decode = AgentInfo_agent_graphql.Utils.membershipStatusV5_decode;

var AgentFragment_membershipStatusV5_fromString = AgentInfo_agent_graphql.Utils.membershipStatusV5_fromString;

var AgentFragment = {
  membershipStatusV5_decode: AgentFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: AgentFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentInfo$FromAgent(props) {
  var __size = props.size;
  var __linkToAgent = props.linkToAgent;
  var overrideBrokerage = props.overrideBrokerage;
  var linkToAgent = __linkToAgent !== undefined ? __linkToAgent : true;
  var size = __size !== undefined ? __size : "xSmall";
  var agent = use(props.agent);
  var brokerage;
  var displayName;
  var id;
  var profilePhoto;
  var id$1 = agent.id;
  var displayName$1 = agent.displayName;
  var brokerage$1 = agent.brokerage;
  var tmp = agent.membershipStatus;
  if (tmp === "ACTIVE" || tmp === "TERMINATED") {
    if (tmp !== "ACTIVE") {
      return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
                  size: size,
                  children: JsxRuntime.jsx(AgentInfo__Jsx3.make, {
                        avatar: AvatarSrcUrl.place_holder,
                        size: size,
                        name: displayName$1,
                        brokerage: "NO LONGER ON TAN"
                      })
                });
    }
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  } else {
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  }
  var avatar = profilePhoto !== undefined ? profilePhoto.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
              avatar: avatar,
              size: size,
              name: Core__Option.getOr(props.overrideDisplayName, displayName),
              brokerage: overrideBrokerage !== undefined ? overrideBrokerage : brokerage,
              wrapName: (function (name) {
                  var content = JsxRuntime.jsx("div", {
                        children: name,
                        className: "font-medium"
                      });
                  if (linkToAgent) {
                    return JsxRuntime.jsx(ButtonsV5.Link.make, {
                                href: "/agents/" + id,
                                onClick: (function (e) {
                                    e.stopPropagation();
                                  }),
                                children: Caml_option.some(content)
                              });
                  } else {
                    return content;
                  }
                }),
              children: Caml_option.some(Core__Option.getOr(props.children, null))
            });
}

var FromAgent = {
  make: AgentInfo$FromAgent
};

function AgentInfo$FromAgentOpt(props) {
  var agent = props.agent;
  if (agent !== undefined) {
    return JsxRuntime.jsx(AgentInfo$FromAgent, {
                agent: Caml_option.valFromOption(agent),
                size: props.size
              });
  } else {
    return null;
  }
}

var FromAgentOpt = {
  make: AgentInfo$FromAgentOpt
};

var make = AgentInfo$FromAgent;

exports.AgentFragment = AgentFragment;
exports.FromAgent = FromAgent;
exports.FromAgentOpt = FromAgentOpt;
exports.make = make;
/* ButtonsV5 Not a pure module */
